module.exports = __webpack_public_path__ + "img/ic_legal.2307ab58.svg";